import { render, staticRenderFns } from "./ImportCertificateDlg.vue?vue&type=template&id=195b0bd3"
import script from "./ImportCertificateDlg.vue?vue&type=script&lang=js"
export * from "./ImportCertificateDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports